export const SEARCH_AND_MERGE_BLOCKED_MESSAGE = 'Search and merge already applied. Deal updates were not sent to the Deal API.';
